// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2XF9F","actions":"GroupTable_actions__1A0w7","deleteModalFooter":"GroupTable_deleteModalFooter__34szt"};